var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"options":_vm.subjectOptions,"props":_vm.subjectProps,"collapse-tags":"","size":"small","clearable":""},on:{"change":_vm.change},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }